import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useStyleConfig,
} from '@chakra-ui/react';
import { closeProTip, openProTip } from '../utils';
import { RiInformationFill, RiPushpinFill } from 'react-icons/ri';
import { AiFillCloseSquare } from 'react-icons/ai';

const ProTip = ({proTip, variant, stateProps}) => {
  /*** TEMPORARY DISABLING ***/
  return null;
  /**********************/
  const buttonVariant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { buttonVariant});
  if (typeof proTip !== 'undefined' && proTip !== '') {
    return (
      <Box>
        <Button
          variant='protip'
          zIndex='1000'
          onClick={() => openProTip(stateProps,proTip)}
        >
          <RiInformationFill /></Button>
        <Modal
          isCentered
          isOpen={stateProps.isPTOpen}
          onClose={stateProps.onPTClose}
        >
          <ModalOverlay />
          <ModalContent
            sx={{
              margin: '16px',
              padding: '8px 0',
              backgroundColor: 'WHITE',
              border: '2px',
              borderColor: 'NAVY_LIGHT',
            }}
          >
            <ModalBody paddingBottom={0}>
              <Text
                sx={{
                  fontWeight: 500,
                  color: 'BLACK',
                  textAlign: 'justify',
                }}
              >
                <Icon as={RiPushpinFill} /> {stateProps.ptMessage}
              </Text>
            </ModalBody>
            <Flex w="100%" justifyContent={'right'}>
              <Button
                sx={{...buttonStyles.empty}}
                      onClick={() => closeProTip(stateProps)}>
                <Icon as={AiFillCloseSquare} w={6} h={6} color="NAVY_LIGHT" />
              </Button>
            </Flex>
          </ModalContent>
        </Modal>
      </Box>
    )
  } else {
    return null;
  }
}

export default ProTip;